/**
 * 时间验证工具函数
 * 用于验证用户选择的时间是否为过去时间
 */

/**
 * 验证选择的时间是否为过去时间
 * @param {string} timeString - 时间字符串
 * @returns {boolean} - 如果是过去时间返回true，否则返回false
 */
export function isTimeInPast(timeString) {
  try {
    // 处理空值或无效输入
    if (!timeString || timeString === 'null' || timeString === 'undefined') {
      return false;
    }

    // 处理ASAP时间
    if (timeString && timeString.toLowerCase().includes('asap')) {
      // ASAP 时间不算过去时间
      return false;
    }

    // 解析时间字符串 - 只处理标准的时间格式
    let selectedDateTime;

    if (timeString && timeString.includes('-') && timeString.includes(':')) {
      // 标准日期时间格式: "2024-01-15 14:30"
      selectedDateTime = new Date(timeString);
    } else if (timeString && timeString.includes(':')) {
      // 只有时间格式: "14:30" - 假设是今天的时间
      const timeParts = timeString.split(':');
      if (timeParts.length >= 2) {
        const hour = parseInt(timeParts[0]) || 0;
        const minute = parseInt(timeParts[1]) || 0;
        const now = new Date();
        selectedDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute);
      } else {
        return false; // 无法解析，不算过去时间
      }
    } else {
      // 其他格式，尝试直接解析
      selectedDateTime = new Date(timeString);
    }

    // 检查日期是否有效
    if (isNaN(selectedDateTime.getTime())) {
      console.log('时间解析错误: 无效的时间格式, 时间字符串:', timeString);
      return false; // 解析失败时不认为是过去时间
    }

    // 比较选择的时间与当前时间
    const now = new Date();
    return selectedDateTime < now;
  } catch (e) {
    console.log('时间解析错误:', e, '时间字符串:', timeString);
    return false; // 解析失败时不认为是过去时间
  }
}

/**
 * 格式化时间显示
 * @param {string} timeString - 时间字符串
 * @returns {string} - 格式化后的时间显示
 */
export function formatTimeDisplay(timeString) {
  if (!timeString) return '';
  
  if (timeString.toLowerCase().includes('asap')) {
    return 'As soon as possible';
  }
  
  try {
    const date = new Date(timeString);
    if (isNaN(date.getTime())) {
      return timeString;
    }
    
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  } catch (e) {
    return timeString;
  }
}
